<template>
  <div class="row">
    <!-- SUPER ADMIN: two cards (Catálogos + Historial) -->
    <template v-if="isSuperAdmin">
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <vb-widgets-lists-21
            name="Catálogos"
            route="/catalogos/principal"
            :image="catalogImage"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <vb-widgets-lists-21
            name="Historial"
            route="/carta_porte/principal"
            :image="historyImage"
          />
        </div>
      </div>
    </template>

    <!-- NO SUPER ADMIN: Just Historial centered -->
    <template v-else>
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <div class="card">
          <vb-widgets-lists-21
            name="Historial"
            route="/carta_porte/principal"
            :image="historyImage"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import VbWidgetsLists21 from '@/@vb/widgets/WidgetsLists/21'
import { getBrandingImagePath } from '@/utils/assets'

function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

function getRoleFromStorages() {

  const directKeys = ['token', 'xToken', 'x-token', 'auth.token', 'jwt', 'access_token']
  for (const k of directKeys) {
    const raw =
      localStorage.getItem(k) ||
      sessionStorage.getItem(k) ||
      null
    const token = typeof raw === 'string' ? raw : null
    if (!token) continue
    const payload = decodeJwtPayload(token)
    if (payload?.role) return payload.role
  }

  const objKeys = ['auth', 'user', 'session']
  for (const k of objKeys) {
    try {
      const obj =
        JSON.parse(localStorage.getItem(k) || 'null') ||
        JSON.parse(sessionStorage.getItem(k) || 'null') ||
        null
      const token = obj?.token
      if (typeof token === 'string') {
        const payload = decodeJwtPayload(token)
        if (payload?.role) return payload.role
      }
    } catch (_) {}
  }
  return null
}

export default {
  name: 'MainIndex',
  components: { VbWidgetsLists21 },
  data() {
    return {
      role: null,
    }
  },
  computed: {
    catalogImage() {
      return getBrandingImagePath('catalog_menu.png')
    },
    historyImage() {
      return getBrandingImagePath('history_menu.png')
    },
    isSuperAdmin() {
      return this.role === 'SUPER ADMIN'
    },
  },
  watch: {
    '$store.state.user.user': {
      handler(nv) {
        if (nv?.role) this.role = nv.role
      },
      deep: false,
    },
    '$store.state.user.data': {
      handler(nv) {
        if (nv?.role) this.role = nv.role
      },
      deep: false,
    },
  },
  created() {
    const u =
      this.$store?.getters?.['user/user'] ||
      this.$store?.state?.user?.user ||
      this.$store?.state?.user?.data ||
      null
    this.role = u?.role || getRoleFromStorages()
  },
}
</script>

<style scoped></style>
